import {Presenter} from '../../../Support/with_presenter';
import {MeService} from '../../../Network/MeService';
import {loadingResponse, NetworkRequestStatus, NetworkResult, successResponse} from '../../../Network/NetworkResult';
import {Me} from '../../../Models/Me';

export class CrewICalPresenter implements Presenter {
    private me: NetworkResult<Me> = loadingResponse();

    public get crewIcalUrl(): NetworkResult<string> {
        if (this.me.status !== NetworkRequestStatus.Success) {
            return this.me;
        }

        return successResponse(this.me.data.crewIcalUrl);
    }

    constructor(private meService: MeService) {}

    public async mount(): Promise<void> {
        this.me = await this.meService.get();
    }

    public unmount(): void {
        /* Noop */
    }
}
